import { DateTime } from 'luxon';

export function timeAgo(input: Date | string): string {
  const now = DateTime.now();
  const date =
    typeof input === 'string'
      ? DateTime.fromISO(input)
      : DateTime.fromJSDate(input);

  const diffInSeconds = Math.floor(now.diff(date, 'seconds').seconds);
  const days = Math.floor(diffInSeconds / 86400);

  if (diffInSeconds < 0 && days >= -1) {
    return 'tomorrow';
  }

  if (diffInSeconds < 60) {
    return 'just now';
  }

  if (diffInSeconds < 3600) {
    const minutes = Math.floor(diffInSeconds / 60);

    return `${minutes} minute${minutes !== 1 ? 's' : ''} ago`;
  }

  if (diffInSeconds < 86400) {
    const hours = Math.floor(diffInSeconds / 3600);

    return `${hours} hour${hours !== 1 ? 's' : ''} ago`;
  }

  if (days === 1) {
    return 'yesterday';
  }

  if (days < 7) {
    return `${days} day${days !== 1 ? 's' : ''} ago`;
  }

  // For older dates, you might want to show the date itself
  return date.toLocaleString(DateTime.DATE_MED);
}

function asDateNoTZ(value: Date | string) {
  if (typeof value === 'string') {
    return DateTime.fromFormat(value.substring(0, 10), 'yyyy-MM-dd');
  }

  return DateTime.fromObject({
    year: value.getFullYear(),
    month: value.getMonth() + 1,
    day: value.getDate(),
  });
}

export function yearsSince(
  date1: Date | string,
  date2: Date | string,
): { years: number; months: number; display: string } {
  const dt1 = asDateNoTZ(date1);
  const dt2 = asDateNoTZ(date2);
  const diff = dt2.diff(dt1, ['year', 'month']);

  let display = '';
  if (diff.years > 1) {
    display += `${diff.years} years`;
  } else if (diff.years === 1) {
    display += '1 year';
  }

  if (diff.months && diff.years) {
    display += ' ';
  }

  const months = Math.floor(diff.months);
  if (months > 1) {
    display += `${months} months`;
  } else if (months === 1) {
    display += `1 month`;
  }

  display += ' ago';

  return { years: diff.years, months: diff.months, display };
}
